export const NOTIFICATIONS_DRAWER_MODULE_ID = 'notifications-drawer-module';

export const LOAD_NOTIFICATIONS_DRAWER_MODULE = () =>
  import('@capital-access/notifications/drawer').then(m => m.NotificationsDrawerModule);
